import { Box, Checkbox, TableCell, TableRow, Typography } from '@mui/material';
import React from 'react';
import { convertArrayToString } from '../../utils/convertArrayToString';
import { toKebabCase } from '../../utils/toKebabCase';
export function MobileColumns({ row, columns, rowIndex, actions, isItemSelected, readonly, onRowClick, onCheckboxClick, }) {
    return (React.createElement(TableRow, { key: `mobileColumns-${rowIndex}`, hover: true, "data-test": row.id + '-row', onClick: () => onRowClick && onRowClick(row), sx: {
            cursor: onRowClick ? 'pointer' : undefined,
        } },
        React.createElement(TableCell, { key: row.id, component: 'th', scope: 'row' },
            React.createElement(Box, { sx: {
                    display: 'flex',
                    flexDirection: { xs: 'column', sm: 'row' },
                    gap: 2,
                    alignItems: { sm: 'center' },
                } },
                React.createElement(Box, { sx: { display: 'flex', flexGrow: { xs: 1, md: 0 } } },
                    !readonly && (React.createElement(Checkbox, { sx: { alignSelf: 'flex-start' }, color: 'primary', checked: isItemSelected, inputProps: {
                            'aria-labelledby': row.id + '-checkbox',
                        }, onClick: (event) => {
                            event.stopPropagation();
                            onCheckboxClick && onCheckboxClick(row.id);
                        } })),
                    React.createElement(Box, { sx: { display: 'flex', flexDirection: 'column', gap: 1, width: '100%' } }, columns.map((column, index) => {
                        const columnValue = row.columns[column.value];
                        const columnDataTest = `${toKebabCase(column.label)}-column`;
                        let value;
                        if (column.render) {
                            value = (React.createElement("div", { key: `mobileColumn-${index}`, "data-test": columnDataTest }, column.render(row, columns.map((column) => column.value))));
                        }
                        else if (columnValue) {
                            value = (React.createElement(Typography, { variant: 'body2', sx: {
                                    color: (theme) => theme.palette.grey[index === 0 ? '900' : '700'],
                                }, key: `mobileColumn-${index}`, "data-test": columnDataTest }, convertArrayToString(columnValue)));
                        }
                        return value;
                    }))),
                !readonly && actions))));
}
